var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wizard"},[_c('ul',{staticClass:"wizard"},_vm._l((_vm.getSteps()),function(step,index){return _c('li',{key:index,staticClass:"wizard-list list",class:[{active: index == _vm.activeIndex}, {passed: index < _vm.activeIndex}]},[_c('span',{staticClass:"listlink",domProps:{"innerHTML":_vm._s(step)}})])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50bc333e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wizard/MainWizard.vue
// module id = null
// module chunks = 